import React, { useState } from "react";
import { Button, Spinner } from "reactstrap";
import { Icon } from "../../components/Component";
import FieldEditor from "./FieldEditor";
import { SECTION_SCHEMAS } from "./sectionSchemas";
import { handlePostApis } from "../../service/Api";

const SectionCard = ({ section, onSaved }) => {
  const schema = SECTION_SCHEMAS[section.section_key];
  const [draft, setDraft] = useState(section);
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  if (!schema) return null;

  const switchId = `hc-active-${section.section_key}`;
  const setContent = (key, value) => setDraft((d) => ({ ...d, content: { ...d.content, [key]: value } }));

  const save = async () => {
    setSaving(true);
    const res = await handlePostApis("admin/homepage/section", {
      section_key: draft.section_key,
      content: draft.content,
      is_active: draft.is_active,
      sort_order: draft.sort_order,
    });
    setSaving(false);
    alert(res?.data?.message || "Something went wrong");
    if (res?.data?.success) onSaved();
  };

  return (
    <div className={`hc-card ${open ? "is-open" : ""}`}>
      <div className="hc-card-head">
        <button type="button" className="hc-toggle" onClick={() => setOpen((o) => !o)} aria-expanded={open}>
          <span className="hc-chevron">
            <Icon name="chevron-right" />
          </span>
          <span className="hc-title">{schema.label}</span>
          {section.is_default && <span className="hc-badge">Default copy</span>}
          {!draft.is_active && <span className="hc-badge is-hidden">Hidden</span>}
        </button>

        <div className="hc-controls">
          <label className="hc-order">
            Order
            <input
              type="number"
              className="form-control"
              value={draft.sort_order}
              onChange={(e) => setDraft((d) => ({ ...d, sort_order: Number(e.target.value) }))}
            />
          </label>
          <div className="custom-control custom-switch hc-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id={switchId}
              checked={!!draft.is_active}
              onChange={(e) => setDraft((d) => ({ ...d, is_active: e.target.checked ? 1 : 0 }))}
            />
            <label className="custom-control-label" htmlFor={switchId}>
              Visible
            </label>
          </div>
          <Button color="primary" size="sm" onClick={save} disabled={saving}>
            {saving ? <Spinner size="sm" /> : "Save"}
          </Button>
        </div>
      </div>

      {open && (
        <div className="hc-card-body">
          {schema.help && (
            <div className="hc-help">
              <Icon name="info" />
              <span>{schema.help}</span>
            </div>
          )}
          {schema.fields.map((field) => (
            <FieldEditor key={field.key} field={field} value={draft.content[field.key]} onChange={(v) => setContent(field.key, v)} />
          ))}
        </div>
      )}
    </div>
  );
};

const SectionsTab = ({ sections, onSaved }) => (
  <>
    <p className="hc-intro">
      Click a section to edit its content. “Default copy” means it has not been saved yet and shows the built-in text. Lower
      order numbers appear first on the homepage.
    </p>
    {sections.map((s) => (
      <SectionCard key={s.section_key} section={s} onSaved={onSaved} />
    ))}
  </>
);

export default SectionsTab;
